<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">
              Debtors - {{commonService.headerName}}
            </h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;"
                    tabindex="-1" (click)="TotalBack()">
              Close Accounts
            </button>
          </div>
        </div>
      </div>
      <hr />
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12">
            <!--<h5 class="fw-bolder font-size-16">
               Debtors
               </h5>-->
            <p class="text-dark">Please enter notes on debtors in the field below.</p>
            <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
          </div>
        </div>
        <form [formGroup]="DebtorsForm" (ngSubmit)="save()">
          <div class="row">
            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-2 p-0 p-md-2">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600"></label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                              <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                              <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-0  ps-lg-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Trade debtors</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="TradeDebtorsWithinOneYear" (change)=" DebtorsCalculations();" maxlength="11" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="TradeDebtorsWithinOneYear_LY" (change)="DebtorsCalculations_LY();" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Other debtors</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="OtherDebtorsBalanceSheetSubtotal" (change)=" DebtorsCalculations();" maxlength="11" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OtherDebtorsBalanceSheetSubtotal_LY" (change)="DebtorsCalculations_LY();" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Prepayments and accrued income</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="PrepaymentsAccruedIncome" (change)=" DebtorsCalculations();" maxlength="11" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="PrepaymentsAccruedIncome_LY" (change)="DebtorsCalculations_LY();" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Total</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end " formControlName="DebtorsDueWithinOneYear" (change)=" DebtorsCalculations();" maxlength="11" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end " formControlName="DebtorsDueWithinOneYear_LY" (change)="DebtorsCalculations_LY();" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-3">
              <label>
                Please enter any additional information in the field below.
              </label>
              <div class="mb-3">
                <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="6" required formControlName="DebtorsFreeøtextComment" maxlength="4000"></textarea>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
